const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(this.include(context, this.source, this.loadTemplate(`6658eadac5ecfa2eea5a01620e93468745eabb665447aa29eae535ae581f7ad0`, `6658eadac5ecfa2eea5a01620e93468745eabb665447aa29eae535ae581f7ad0`, 1, 92), undefined, true, false, 1));
            }

            getTemplateName() {
                return `6658eadac5ecfa2eea5a01620e93468745eabb665447aa29eae535ae581f7ad0`;
            }

            getSourceContext() {
                return new this.Source(``, `6658eadac5ecfa2eea5a01620e93468745eabb665447aa29eae535ae581f7ad0`, ``);
            }
        }],
        [92, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/page/page.twig`, `6658eadac5ecfa2eea5a01620e93468745eabb665447aa29eae535ae581f7ad0`, 1);

                this.blocks = new Map([
                    ['header', [this, 'block_header']],
                    ['content', [this, 'block_content']],
                    ['footer', [this, 'block_footer']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/page/page.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_header(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`
    <!-- standard Sky Nav component -->
    `);
                this.echo(this.include(context, this.source, `@cloudfour/components/sky-nav/sky-nav.twig`, new Map([[`class`, `t-dark`], [`menu`, (context.has(`skyNavMenu`) ? context.get(`skyNavMenu`) : null)]]), false, false, 5));
                this.echo(`
  `);
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`
    <!-- the Error is a full-height Cloud Cover component -->
    `);
                this.echo(this.include(context, this.source, this.loadTemplate(`6658eadac5ecfa2eea5a01620e93468745eabb665447aa29eae535ae581f7ad0`, `6658eadac5ecfa2eea5a01620e93468745eabb665447aa29eae535ae581f7ad0`, 14, 91), new Map([[`class`, `c-cloud-cover--full-height`]]), false, false, 14));
                this.echo(`
  `);
            }

            block_footer(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`
    <!-- standard Ground Nav component -->
    `);
                this.echo(this.include(context, this.source, `@cloudfour/components/ground-nav/ground-nav.twig`, new Map([[`menu`, (context.has(`menu`) ? context.get(`menu`) : null)], [`social`, (context.has(`social`) ? context.get(`social`) : null)], [`action`, (context.has(`action`) ? context.get(`action`) : null)], [`organization`, (context.has(`organization`) ? context.get(`organization`) : null)]]), false, false, 50));
                this.echo(`
  `);
            }

            getTemplateName() {
                return `6658eadac5ecfa2eea5a01620e93468745eabb665447aa29eae535ae581f7ad0`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `6658eadac5ecfa2eea5a01620e93468745eabb665447aa29eae535ae581f7ad0`, ``);
            }
        }],
        [91, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/components/cloud-cover/cloud-cover.twig`, `6658eadac5ecfa2eea5a01620e93468745eabb665447aa29eae535ae581f7ad0`, 14);

                this.blocks = new Map([
                    ['heading', [this, 'block_heading']],
                    ['content', [this, 'block_content']],
                    ['scene', [this, 'block_scene']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/components/cloud-cover/cloud-cover.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_heading(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`        `);
                this.echo(this.include(context, this.source, `@cloudfour/components/heading/heading.twig`, new Map([[`content`, `Cloud 404!`], [`level`,  -2], [`class`, `heading`]]), false, false, 18));
                this.echo(`      `);
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`        <p>We can't seem to find the page you're looking for. But don't give up! Try browsing our <a href="#">list of topics</a> or use this handy-dandy search...</p>
        `);
                this.echo(this.include(context, this.source, this.loadTemplate(`6658eadac5ecfa2eea5a01620e93468745eabb665447aa29eae535ae581f7ad0`, `6658eadac5ecfa2eea5a01620e93468745eabb665447aa29eae535ae581f7ad0`, 26, 90), undefined, true, false, 26));
                this.echo(`      `);
            }

            block_scene(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`        <img class="c-cloud-cover__scene-object" src="media/404-robot.svg" />
      `);
            }

            getTemplateName() {
                return `6658eadac5ecfa2eea5a01620e93468745eabb665447aa29eae535ae581f7ad0`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `6658eadac5ecfa2eea5a01620e93468745eabb665447aa29eae535ae581f7ad0`, ``);
            }
        }],
        [90, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/input-group/input-group.twig`, `6658eadac5ecfa2eea5a01620e93468745eabb665447aa29eae535ae581f7ad0`, 26);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/input-group/input-group.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`            `);
                this.echo(this.include(context, this.source, `@cloudfour/components/input/input.twig`, undefined, false, false, 28));
                this.echo(`            `);
                this.echo(this.include(context, this.source, this.loadTemplate(`6658eadac5ecfa2eea5a01620e93468745eabb665447aa29eae535ae581f7ad0`, `6658eadac5ecfa2eea5a01620e93468745eabb665447aa29eae535ae581f7ad0`, 29, 89), new Map([[`class`, `search-btn`]]), true, false, 29));
                this.echo(`          `);
            }

            getTemplateName() {
                return `6658eadac5ecfa2eea5a01620e93468745eabb665447aa29eae535ae581f7ad0`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `6658eadac5ecfa2eea5a01620e93468745eabb665447aa29eae535ae581f7ad0`, ``);
            }
        }],
        [89, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/components/button/button.twig`, `6658eadac5ecfa2eea5a01620e93468745eabb665447aa29eae535ae581f7ad0`, 29);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/components/button/button.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`                `);
                this.echo(this.include(context, this.source, `@cloudfour/components/icon/icon.twig`, new Map([[`name`, `magnifying-glass`]]), true, false, 33));
                this.echo(`              `);
            }

            getTemplateName() {
                return `6658eadac5ecfa2eea5a01620e93468745eabb665447aa29eae535ae581f7ad0`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `6658eadac5ecfa2eea5a01620e93468745eabb665447aa29eae535ae581f7ad0`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, '6658eadac5ecfa2eea5a01620e93468745eabb665447aa29eae535ae581f7ad0');

let template = env.loadTemplate('6658eadac5ecfa2eea5a01620e93468745eabb665447aa29eae535ae581f7ad0');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/prototypes/error/example/404.twig", args: context }
     );
     return rendered;;
};